module.exports = __webpack_public_path__ + "static/media/recurring-payment-fr.ac2c50f9.png";